import ExceptionHandling from './ExceptionHandling.js'
import { useStore, ActionTypes } from "../store.ts";
import instance from './index';
import axios from 'axios';
import { promotionUpdateStatus } from '../state/promotionState.js';
import Toaster from "../helpers/Toaster";

export default class PromotionalSMSService {
	
	
	getItems(keyword, start) {
		
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/promotions_list';
		const formData = new FormData();
		formData.append('keyword', keyword);
		formData.append('start', start);
		
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then((res) => {
			return res.data;
		})
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	saveItem(postObj, stateObj, currentUserID) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/add_promotions';
		const formData = new FormData();
		formData.append('promotion_name', stateObj.promotionName);
		formData.append('message', stateObj.message);
		formData.append('contact_numbers', stateObj.contactNumbers);
		formData.append('mask_type', postObj.maskType.key);
		formData.append('status', postObj.status);
		formData.append('created_user', currentUserID);
		
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then((res) => {
			
			res.data.promotionDetail.status = "Created";
			//this.sendSMS(payload,res.data.promotionDetail.id);
			return res.data;
		})
		.catch((e) => {
			toast.
			ExceptionHandling.HandleErrors(e);
			throw e;  // Re-throw to allow Vue component to catch the error
		})
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}

	sendSMS(data,promotionId) {
		let toast = new Toaster();
		const api = '/api/send_promo_sms';
		return instance()({
			method: 'post',
			url: api,
			data: data,
		}).then((res) => {
			this.updatePromotion(promotionId,"pending",res.data.tracking_id); 
			return res.data;
		})
		.catch((e) => {
			//toast.showError("Error: Please check your internet connection");
			ExceptionHandling.HandleErrors(e);
			throw 'Please check your internet connection';  // Re-throw to allow Vue component to catch the error
			
		})
		.finally(() => {
			//store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}

	
	updatePromotion(id,status,transaction_id) {
        const store = useStore(); // Access Vuex store
        store.dispatch(ActionTypes.PROGRESS_BAR, true); // Show progress bar
        const api = '/api/edit_promotions'; // API endpoint
        return instance()(
            {
                method: 'post',
                url: api,
                data: {
					id: id,
					status:status,
					transaction_id:transaction_id,
				},
                   // Data sent to the server
            }
        )
            .then((res) => {
				promotionUpdateStatus.value = res.data;
				return res.data;
			}) // Return the response data
            .catch((e) => ExceptionHandling.HandleErrors(e)) // Handle errors
            .finally(() => {
                store.dispatch(ActionTypes.PROGRESS_BAR, false); // Hide progress bar
            });
    }


	getSMSPackages() {
		return axios.get('/api/sms_packages')
		  .then(response => response.data)
		  .catch(error => {
			throw error;
		  });
	  }
	requestCampaignStatus(id,tracking_id){
		const api = '/api/request_campaign_status';
		return instance()({
			method: 'post',
			url: api,
			data: {
				"tracking_id" : tracking_id
			},
		}).then((res) => {
			let status = res.data.campaign_status['campaign status'];
			if(status!=="pending"){
				this.updatePromotion(id,status,tracking_id);
			}			
			return res;
		})
		.catch((e) => {
			ExceptionHandling.HandleErrors(e);
			throw e;  // Re-throw to allow Vue component to catch the error
		})
		.finally(() => {
			//store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}

	

	

}